import type { ReactNode, JSX } from 'react';
import Stack from '@mui/material/Stack';

type FormStackProps = {
  children: ReactNode;
};

export const FormStack = ({ children }: FormStackProps): JSX.Element => {
  return (
    <Stack
      sx={{
        gap: 6,
      }}
    >
      {children}
    </Stack>
  );
};
